function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Filters.css';
import React, { useEffect, useState } from 'react';
import { canUseDOM, get } from '../../utils';
import { ReactComponent as BackArrow } from "../../resources/icons/chevronLeftCarouselSharedCh.svg";
import { ReactComponent as IconFilter } from '../../resources/icons/filter.svg';
import { filtersStylesLtr, filtersStylesRtl } from '../DynamicListingComponent/DynamicListingComponent';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import DropDown from './DropDown';
import Switch from './Switch';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import SortDropdown from './SortDropdown';
import { qsToObject } from '../../utils/querystring';
import { useLocation, useHistory } from 'react-router-dom';

// TODO deprecated
// 1) deprecatedWithSearchColParams
// 2) DeprecatedWithSearchFacetsTagWithFilter
// 3) deprecatedFilterIcon
// 4) deprecatedOnlyFilter

const Filter = _ref => {
  let {
    fields,
    showLabel,
    clearAllLabel,
    facets,
    params,
    nbHits,
    setListingFilter,
    facetsStats = {},
    resetFilterCallback,
    FiltersCopy,
    lang,
    firstQuery,
    dictionary,
    allTagLabel,
    buttonsDictionary,
    hits,
    defaultFacets,
    analytics,
    eventsAnalytics,
    showClearAll = true,
    apllyFiltersOnChange = false,
    resetAllFiltersCallback,
    searchIndex = '',
    setIsTypeSetToUrl,
    searchTextValue,
    setSearchTextValue
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const filtersArray = get(fields, 'values');
  const filterWrapperRef = /*#__PURE__*/React.createRef();
  const location = useLocation();
  let history = useHistory();
  const [filterSubpanelText, setFilterSubpanelText] = React.useState('');
  const [clearAlllFilters, setclearAlllFilters] = React.useState(false);
  const [firstFilter, setFirstFilter] = React.useState(true);
  const [startPage, setStartPage] = React.useState(true);
  const [filtersValue, setFiltersValue] = React.useState({});
  const queryParams = qsToObject(location.search);
  const [isSmallScreen, setIsSmallScreen] = useState(canUseDOM && window.matchMedia('(max-width: 1200px)').matches);
  const checkIsSmallScreen = () => {
    const isSmallScreen = canUseDOM && window.innerWidth <= 1200;
    setIsSmallScreen(isSmallScreen);
  };
  useEffect(() => {
    window.addEventListener('resize', checkIsSmallScreen);
    return () => {
      window.removeEventListener('resize', checkIsSmallScreen);
    };
  }, []);
  React.useEffect(() => {
    filtersArray && filtersArray.map(el => {
      const preselectedTags = el.preselectedTags && el.preselectedTags.values.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      const fieldNameItem = get(el, 'fieldNameItem.item.fieldName.value');
      const queries = queryParams[`${fieldNameItem}`];
      if (!queries) {
        setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [el.name]: {
            value: el.preselectedTags && el.preselectedTags.values.length !== 0 ? preselectedTags.join(',') : null,
            facet: fieldNameItem
          }
        }));
      } else {
        setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [el.name]: {
            value: queries,
            facet: fieldNameItem
          }
        }));
      }
    });
  }, []);
  React.useEffect(() => {
    let count = 0;
    for (let key in filtersValue) {
      const isFullFalseObj = () => {
        let isFullFalseObj = true;
        if (filtersValue[key].value !== null) {
          Object.values(filtersValue[key].value).forEach(el => {
            if (el) {
              isFullFalseObj = false;
            }
          });
        }
        return isFullFalseObj;
      };
      if (typeof filtersValue[key].value === 'string' ? filtersValue[key].value !== null : !isFullFalseObj()) {
        count = count + 1;
      }
    }
  }, [filtersValue]);
  const filterSubPanelToggle = function (toggle) {
    let closePanel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (filterWrapperRef.current) {
      // close common filter dropdown
      if (toggle && closePanel) {
        filterWrapperRef.current.classList.remove('filter__wrapper--open');
        togglePanelHandler(false);
        setStartPage(true);
        setFirstFilter(true);
      }
    }
  };
  const clearKeyPressHandler = e => {
    if (e.which === 13 || e.which === 32) {
      e.preventDefault();
      clearAllCallback();
    }
  };
  const setFilter = function () {
    let firstFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setclearAlllFilters(false);
    setFirstFilter(firstFilter);
    setListingFilter();
  };
  const getFilterValue = (fieldName, facet, filterValue) => {
    if (filterValue === null || filterValue === '' || filterValue.length === 0 || Object.keys(filterValue).length === 0) {
      setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldName]: {
          value: null,
          facet: facet
        }
      }));
    } else {
      setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldName]: {
          value: filterValue,
          facet: facet
        }
      }));
    }
  };
  const clearAllCallback = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['filterClearAllDateAnalytics'], params));
    setclearAlllFilters(true);
    filterSubPanelToggle(true, false);
    setTimeout(() => {
      filtersArray && filtersArray.map(el => {
        const facetName = get(el, 'fieldNameItem.item.fieldName.value');
        setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [el.name]: {
            value: null,
            facet: facetName
          }
        }));
      });
    }, 10);
  };
  const controlBackBtn = isOpen => {
    setStartPage(isOpen);
  };
  const theme = get(sitecoreContext, 'themesOfPage');
  const themePrimary = get(theme, 'primary');
  const themePrimary__active = get(theme, 'primary_active');
  const columnsClass = filtersArray.length === 2 ? 'col-md-6' : 'col-md-3';
  const facetsTags = () => filtersArray && filtersArray.map((filter, index) => {
    const fieldTypeItem = get(filter, 'fieldTypeItem.item.fieldType.value');
    const fieldNameItem = get(filter, 'fieldNameItem.item.fieldName.value');
    const fieldNamesItem = get(filter, 'fieldNameItems.items.0.fieldName.value');
    let itemfacets;
    if (facets && defaultFacets) {
      itemfacets = facets[fieldNameItem] || facets[fieldNamesItem] || facets[fieldNameItem + 'RangeIndex'];
    }
    if (fieldTypeItem === 'Toggle Single Select') {
      return /*#__PURE__*/React.createElement(Switch, {
        key: index,
        facets: itemfacets,
        facetsName: fieldNameItem,
        fields: filter,
        wrapperToggle: filterSubPanelToggle,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        dictionary: dictionary,
        allTagLabel: allTagLabel,
        buttonsDictionary: buttonsDictionary,
        analytics: analytics,
        getFilterValue: getFilterValue,
        rtl: rtl,
        resetAllFiltersCallback: resetAllFiltersCallback,
        setIsTypeSetToUrl: setIsTypeSetToUrl
      });
    } else {
      return null;
    }
  });
  const colParams = "col-lg-12";
  const deprecatedWithSearchColParams = "col-xl-6 col-lg-4";
  const togglePanelHandler = close => {
    if (close !== false && document.body.style.overflowY === '') {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = '';
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    themePrimary: themePrimary,
    themePrimary__active: themePrimary__active,
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__wrapper row",
    ref: filterWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: `body-medium filter__header-links js-filters-close ${startPage ? 'cancel' : 'back'}`,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params), 'Back');
      if (startPage) {
        setStartPage(true);
        filterWrapperRef.current.classList.remove('filter__wrapper--open');
        togglePanelHandler(false);
      } else {
        setStartPage(true);
        setFirstFilter(true);
      }
    }
  }, /*#__PURE__*/React.createElement(BackArrow, {
    className: "brand-icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header-text body-medium"
  }, /*#__PURE__*/React.createElement("span", null, FiltersCopy, " "), /*#__PURE__*/React.createElement("span", {
    className: "js-opened-filter-label submenu__text"
  }, filterSubpanelText))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-links",
    onClick: clearAllCallback
  }, clearAllLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "filter__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filtersArray && filtersArray.map((filter, index) => {
    const fieldTypeItem = get(filter, 'fieldTypeItem.item.fieldType.value');
    const fieldNameItem = get(filter, 'fieldNameItem.item.fieldName.value');
    let itemfacets;
    let defaultItemFacets;
    if (facets && defaultFacets) {
      itemfacets = facets[fieldNameItem];
      defaultItemFacets = defaultFacets[fieldNameItem];
    }
    if (fieldTypeItem === 'Toggle Single Select') {
      return /*#__PURE__*/React.createElement(DropDown, {
        columnsClass: columnsClass,
        key: index,
        hideAmount: true,
        fields: filter,
        showLabel: showLabel,
        clearAllLabel: clearAllLabel,
        facetsName: fieldNameItem,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analyticss: {
          eventsAnalytics,
          analytics,
          params
        },
        hideShowButton: apllyFiltersOnChange,
        keepOpenOnChange: true,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        allTagLabel: allTagLabel,
        rtl: rtl
      });
    } else if (fieldTypeItem === 'Sort') {
      return /*#__PURE__*/React.createElement(SortDropdown, {
        key: index,
        columnsClass: columnsClass,
        fields: filter,
        showLabel: showLabel,
        clearAllLabel: clearAllLabel,
        facets: get(filter, 'fieldNameItems.items'),
        facetsName: get(filter, 'fieldNameItems.items', []).map(f => get(f, 'fieldName.value', '')),
        dictionary: dictionary,
        defaultFacets: get(filter, 'fieldNameItems.items'),
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        searchIndex: searchIndex
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      });
    }
  }))), filtersArray.length > 1 && showClearAll && /*#__PURE__*/React.createElement("div", {
    className: "col-md-auto col-lg-2 d-flex justify-content-end align-items-end filter__col-clear"
  }, /*#__PURE__*/React.createElement("button", {
    onKeyPress: clearKeyPressHandler,
    onClick: clearAllCallback,
    className: "body-medium link-clear filter-panel__row-clear btn--reset"
  }, clearAllLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "row dLineNone"
  }, /*#__PURE__*/React.createElement("div", {
    className: `col-md offset-xl-1`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters-bottom-hr"
  }))))))), facets ? /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row wrapperServiceListingFilter"
  }, /*#__PURE__*/React.createElement("div", {
    className: `facetsTagWithFilter ${isSmallScreen ? "onlyFilter" : colParams}`
  }, !isSmallScreen ? facetsTags() : null, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      filterWrapperRef.current.classList.add('filter__wrapper--open');
      togglePanelHandler(true);
    },
    className: "filterIcon"
  }, /*#__PURE__*/React.createElement(IconFilter, null), /*#__PURE__*/React.createElement("span", {
    className: "filterIconText"
  }, FiltersCopy))), isSmallScreen ? /*#__PURE__*/React.createElement("div", {
    className: "col-12 hiddenOnMobile"
  }, facetsTags()) : null)) : null));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    themePrimary,
    themePrimary__active
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles}  ${rtl ? filtersStylesRtl : filtersStylesLtr} ${rtl ? rtlStyles : ''} `
  }, children);
};
export default Filter;
const commonStyles = "ci8xbfd";
const rtlStyles = "r10328l4";